// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-block-list-info-boxes-custom a h3 svg,.c-block-list-info-boxes-custom a img{transition:all .25s ease-in-out}@media (hover:hover){.c-block-list-info-boxes-custom a:hover h3 svg{margin-left:15px!important}.c-block-list-info-boxes-custom a:hover img{transform:scale(1.1)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
